/**
 * Toast global — dispara un evento que AppToast.vue escucha.
 * Uso: showToast('Guardado correctamente', 'success')
 *      showToast('Sync ok', 'success', { position: 'top', duration: 6000 })
 * Tipos: 'success' | 'danger' | 'warning' | 'info'
 */
export function showToast(message, type = 'success', options = {}) {
  window.dispatchEvent(new CustomEvent('app:toast', {
    detail: {
      message,
      type,
      position: options.position || 'bottom',
      duration: options.duration || 3500
    }
  }));
}
